import { render, staticRenderFns } from "./ClockStyle.vue?vue&type=template&id=c6fb697c&"
import script from "./ClockStyle.vue?vue&type=script&lang=ts&"
export * from "./ClockStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports